import { HOST, } from "common/constants";
import React, { useEffect, useState } from "react";
import { Container, Typography, useMediaQuery } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

import { BreadCrumbs } from "components/BreadCrumbs";
import NewsDescription from "components/NewsDescription/NewsDescription";
import NewsList from "components/NewsList/NewsList";

import classes from "./newsId.module.scss";
import { useTranslation } from "react-i18next";

const NewsId = () => {
  const isMobile = useMediaQuery("(max-width: 575px)");
  const { id } = useParams(); // тут должен быть slug
  const { t, i18n } = useTranslation();

  const [news, setNews] = useState(null);

  const newsListLimit = isMobile ? 3 : 4;

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axios.get(
          `${HOST}/api/v1/news/${id}/`
        );
        setNews(res.data);
      } catch (err) {
        console.error("Ошибка при получении новости:", err);
      }
    };

    fetchNews();
  }, [id]);

  const link = (
    <Link to="/news" style={{ textDecoration: "none" }}>
      <Typography className={classes.prevPath}>{t("news")} /</Typography>
    </Link>
  );

  const currentLang = i18n.language;
  const path = news?.[`title_${currentLang}`] || news?.title || "";

  return (
    <Container>
      {news && (
        <>
          <BreadCrumbs path={path} prevPath={link} />
          <NewsDescription news={news} />
          <Typography className={classes.title}>{t("otherNews")}</Typography>
          <NewsList variant="row" count={newsListLimit} listOf="newsMore" />
        </>
      )}
    </Container>
  );
};

export default NewsId;
